import { render, staticRenderFns } from "./GeoMapV2.vue?vue&type=template&id=89880d18&scoped=true"
import script from "./GeoMapV2.vue?vue&type=script&lang=js"
export * from "./GeoMapV2.vue?vue&type=script&lang=js"
import style0 from "./GeoMapV2.vue?vue&type=style&index=0&id=89880d18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89880d18",
  null
  
)

export default component.exports